import { Component, OnInit } from '@angular/core';

import * as Services from '@shared/core/services';
import { Controllers } from '@shared/core/controllers';

import { ModalViewComponent } from '../modal-view.shared.component';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

@Component({
    selector: 'shared-modal-for-delete-profile',
    templateUrl: './modal-for-delete-profile.shared.component.html',
    styleUrls: ['./modal-for-delete-profile.shared.component.scss']
})
export class ModalForDeleteProfileComponent extends ModalViewComponent implements OnInit {
    public loading$!: Observable<OLO.Components.LOADING_STATUS>;
    public isAuthorized$!: Observable<boolean>;

    constructor(
        public modalsService: Services.ModalsService,
        public heightAdjustService: Services.HeightAdjustService,
        public routeService: Services.RouteService,
        public controllers: Controllers,
    ) {
        super(modalsService, heightAdjustService, null);
    }

    ngOnInit(): void {
        this.size = 'xsm';

        this.loading$ = this.controllers.members.deleteAccountStatus$();
        this.isAuthorized$ = this.controllers.members.isAuthorized$()
            .pipe(
                tap(isAuthorized => {
                    if (!isAuthorized) {
                        this.handleHeightUpdate();
                    }
                })
            );
    }

    public handleNoWayClick($event: MouseEvent): void {
        this.close();
    }

    public handleDeleteProfileClick($event: MouseEvent): void {
        this.controllers.members.deleteProfile();
    }

    public handleContactClick($event: Event): void {
        this.controllers.appSettings.contactUsClick();
    }
}
